import { memo } from 'react';
import { Alert } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'translations';
import { LINKS } from 'configuration';

interface NetworkAllowanceWarningProps {
  item?: any;
}

const NetworkAllowanceWarning = memo(({ item = null }: NetworkAllowanceWarningProps) => {
  const { t, tC } = useTranslation('features', 'billingAlerts');
  const warning = item && item?.meta?.type === 'network' && item?.meta?.warning;

  if (!warning || warning[0].code !== 441000001) {
    return null;
  }

  return (
    <Alert
      type="warning"
      closable
      message={
        <>
          {tC('deviceAllowanceWarning')} {tC('modifyDeviceAllowanceMessage')}{' '}
          <Link to={LINKS.activeSubscription}>{t('modifyDeviceAllowanceLink')}</Link>.
        </>
      }
    />
  );
});

NetworkAllowanceWarning.displayName = 'NetworkAllowanceWarning';

export default NetworkAllowanceWarning;
